import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"


import { defineAsyncComponent, PropType } from 'vue';

const __default__ = { name: 'JsonComponent' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  text: String as PropType<string>,
  custom_component_name: String as PropType<string>,
},
  setup(__props) {

const props = __props




const componentName = props.custom_component_name || 'DefaultComponent';

const component = defineAsyncComponent(() => import(`@/components/${componentName}.vue`));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component)), { json: __props.text }, null, 8, ["json"]))
  ]))
}
}

})